export default __webpack_public_path__ + "static/media/gallery_00.9e3d9c3e.jpg";